import { createContext } from "react";

export const EntityPreviewContext = createContext<boolean>(false);
